import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// const express = require("express");
// const fetch = require("node-fetch");
// const app = express();
// const PORT = process.env.PORT || 5000;

// Google Sheets CSV URL
// const SHEET_CSV_URL = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vRUP8NJVNlS2Nq8RGSzl4quPyUmhKdCrfc1atgC_hWtFhBa_Fc7jfQ9jycYx1V91v1KJG2BGKGgZzz8/pub?output=csv';

// app.get("/api/jobs", async (req, res) => {
//   try {
//     const response = await fetch(SHEET_CSV_URL);
//     const text = await response.text();
//     const rows = text.split("\n").map(row => row.split(","));
//     const headers = rows[0];
//     const jobs = rows.slice(1).map(row => {
//       return headers.reduce((acc, header, i) => {
//         acc[header.trim()] = row[i]?.trim() || '';
//         return acc;
//       }, {});
//     });
//     res.json(jobs);
//   } catch (error) {
//     console.error("Failed to fetch jobs:", error);
//     res.status(500).json({ error: "Internal Server Error" });
//   }
// });

// app.listen(PORT, () => {
//   console.log(`Job API server running on http://localhost:${PORT}`);
// });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
